import { SchedulerPostType } from '@/utils/hooks/context/scheduler/types';

import Modal from '@/components/base/Modal';
import { Content } from '@/components/pages/scheduler/deletePostModal/content';

type DeletePostModalProps = {
    isOpen: boolean;
    toggle: () => void;
    post: SchedulerPostType;
    deleteSuccess: () => void;
};

export const DeletePostModal = ({ isOpen, toggle, post, deleteSuccess }: DeletePostModalProps) => {
    return (
        <Modal open={isOpen} onDismiss={toggle}>
            <Content post={post} toggle={toggle} deleteSuccess={deleteSuccess} />
        </Modal>
    );
};
